<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary p-10">
          <!-- Nav tabs -->
          <ul class="nav nav-tabs" role="tablist">
            <li role="presentation" class="active">
              <a href="#acordo" aria-controls="acordo" role="tab" data-toggle="tab">Novo Acordo</a>
            </li>
            <li role="presentation">
              <a
                href="#agendamento"
                aria-controls="agendamento"
                role="tab"
                data-toggle="tab"
              >Agendamento</a>
            </li>
          </ul>

          <div class="box-body">
            <!-- Tab panes -->
            <div class="tab-content">
              <div role="tabpanel" class="tab-pane active" id="acordo">
                <inadimplente-acordo :pessoaId="$route.params.inadimplenteId"></inadimplente-acordo>
              </div>
              <div role="tabpanel" class="tab-pane" id="agendamento">
                <inadimplente-agendamento :pessoaId="$route.params.inadimplenteId"></inadimplente-agendamento>
              </div>
            </div>
          </div>
          <!-- /.box-body -->
        </div>
        <!-- /.box -->
      </div>
      <!-- /.col-md-12 -->
    </div>
    <!-- /.row -->
  </section>
</template>

<script>
import InadimplenteAcordo from "./inadimplenteAcordo";
import InadimplenteAgendamento from "./inadimplenteAgendamento";

export default {
  components: {
    InadimplenteAcordo,
    InadimplenteAgendamento
  },
  data: () => ({
  }),
  mounted() {
  },
  
  methods: {
    
  },
};
</script>
<style scoped>
.p-10 {
  padding: 10px;
}
.mt-20 {
  margin-top: 20px;
}
.mt-40 {
  margin-top: 40px;
}
.fw-600 {
  font-weight: 600;
}
.d-flex {
  display: flex;
}
.aling-flex-end {
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// inadimplenteDetalhe.vue?d31d1396